import React from 'react';
import NavBar from '../../components/navbar/navbar.component';
import Header from '../../components/header/header.component';
import About from '../../components/about/about.component';
import Projects from '../../components/projects/projects.component';
import Contact from '../../components/contact/contact.component';
import Footer from '../../components/footer/footer.component';

import './homepage.styles.css';

const HomePage = () => (
    <div className="homepage">
        <NavBar />
        <Header />
        <About />
        <Projects />
        <Contact />
        <Footer />
    </div>
);

export default HomePage;